import React, { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { SimpleDialog, makeStyles, useMediaQuery } from '@ellucian/react-design-system/core';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material';
import useApplicationForm from './useApplicationForm';
import { fontFamilyDefault, spacing50 } from '@ellucian/react-design-system/core/styles/tokens';
import { replacePlaceholders } from '../Helpers/replacePlaceholders';
import HtmlFormattedMessage from '../HtmlFormattedMessage/HtmlFormattedMessage';
import { useSelector } from 'react-redux';
import ethosModels from '@nsr/applicant-apply-shared/src/constants/ethosModels';
import { useApi } from '../ApiContext/ApiContext';

const useStyles = makeStyles(() => ({
    root: {
        display: 'grid',
        gridAutoRows: 'min-content',
        gridGap: spacing50,
    },
    content: {
        fontFamily: fontFamilyDefault,
    }
}));

const selectApplicationValues = state => state.application.values;

const SubmittedDialog = ({ isOpen, onClose }) => {
    const intl = useIntl();
    const { formatMessage } = intl;
    const classes = useStyles();
    const appValues = useSelector(selectApplicationValues);
    const api = useApi();
    const { template, adminTenant } = useApplicationForm();
    const globalSettings = window.PRELOADED_STATE?.globalSettings || adminTenant;
    const { supportedGraphqlModels } = globalSettings;


    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const handleClose = useCallback(() => onClose(), [onClose]);
    const [htmlText, setHtmlText] = useState('');

    useEffect(() => {
        const contentText = formatMessage({ id: template?.settings?.confirmationDescriptionId }) || '';
        const getText = async () => {
            const fetchedHtmlText = await replacePlaceholders(decodeURI(contentText), appValues, template, ethosModels.application.name, supportedGraphqlModels, api);
            setHtmlText(fetchedHtmlText);
        };
        getText();
    }, [template?.settings?.confirmationDescriptionId, intl]);

    return (
        <SimpleDialog
            buttonConfig={[
                {
                    id: 'ok',
                    title: formatMessage({ id: 'dialogOk' })
                },
            ]}
            title=""
            open={isOpen}
            closeOnClickOut={false}
            handleButtonClick={handleClose}
            showTitleBarClose={true}
            onClose={handleClose}
            fullScreen={isMobile}
        >
            <div className={classes.content}>
                <HtmlFormattedMessage htmlString={htmlText} />
            </div>
        </SimpleDialog>
    );
};

SubmittedDialog.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
};
export default SubmittedDialog;
